export class ConversationDto{
    idPartner: string;
  idUserPartner: string;
  iduseradherent: string;
}